import "./style.scss";
import TrainingFormatsCardEducation from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsCardEducation.png";
import TrainingFormatsCardEducationBg from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsCardEducationBg.png";
import TrainingFormatsCardForm from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsCardForm.png";
import TrainingFormatsCardFormBg from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsCardFormBg.png";
import TrainingFormatsCardsPointSvg from "@/src/svg/TrainingFormatsCardsPointSvg";
import { Link } from "react-router-dom";

const TrainingFormatsCardsMob = () => {
  return (
    <div className="training-formats-mob-cards">
      <Link to={"/single-page/education-personal"} className="training-formats-mob-card">
        <div className="training-formats-mob-card-content">
          <div className="training-formats-mob-card-title">
            <div className="training-formats-mob-card-title-text">
              <p>Очная форма обучения</p>
            </div>
            <div className="training-formats-mob-card-title-img">
              <img src={TrainingFormatsCardEducation} alt="Training Formats Card Education" />
            </div>
          </div>
          <div className="training-formats-mob-card-subtitle">
            <p>Основные преимущества:</p>
          </div>
          <ul className="training-formats-mob-card-ul">
            <li className="training-formats-mob-card-li">Живое общение с преподавателями;</li>
            <li className="training-formats-mob-card-li">Практика на месте;</li>
            <li className="training-formats-mob-card-li">Кампусная жизнь студета;</li>
            <li className="training-formats-mob-card-li">Быстрая связь обратная связь;</li>
            <li className="training-formats-mob-card-li">Доступ к университетской библиотек.</li>
          </ul>
        </div>
        <div className="training-formats-mob-card-image">
          <img src={TrainingFormatsCardEducationBg} alt="Training Formats Card Education Bg" />
          <TrainingFormatsCardsPointSvg />
        </div>
      </Link>
      <Link to={"/single-page/education-remotely"} className="training-formats-mob-card">
        <div className="training-formats-mob-card-content">
          <div className="training-formats-mob-card-title">
            <div className="training-formats-mob-card-title-text">
              <p>Дистанционная (онлайн) форма</p>
            </div>
            <div className="training-formats-mob-card-title-img">
              <img src={TrainingFormatsCardForm} alt="Training Formats Card Education" />
            </div>
          </div>
          <div className="training-formats-mob-card-subtitle">
            <p>Основные преимущества:</p>
          </div>
          <ul className="training-formats-mob-card-ul">
            <li className="training-formats-mob-card-li">Учись из любой точки мира;</li>
            <li className="training-formats-mob-card-li">Цифровой формат;</li>
            <li className="training-formats-mob-card-li">Свободный график;</li>
            <li className="training-formats-mob-card-li">Доступ 24/7;</li>
            <li className="training-formats-mob-card-li">Учёба из дома.</li>
          </ul>
        </div>
        <div className="training-formats-mob-card-image">
          <img src={TrainingFormatsCardFormBg} alt="Training Formats Card Education Bg" />
          <TrainingFormatsCardsPointSvg />
        </div>
      </Link>
    </div>
  );
};

export default TrainingFormatsCardsMob;
